import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import LoadingData from "../../Common/LoadingData";

const AddCourse = () => {
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [membership, setMembership] = useState("");
  const [level, setLevel] = useState("A1");
  const [photo, setPhoto] = useState();
  const [price, setPrice] = useState(0);
  const [instructor, setInstructor] = useState("");
  const [instructorNames, setInstructorNames] = useState([]);
  const [list1, setList1] = useState("");
  const [list2, setList2] = useState("");
  const [list3, setList3] = useState("");
  const [list4, setList4] = useState("");
  const [isPending, setIsPending] = useState(false);
  const [loading, setLoading] = useState(true);

  const history = useHistory();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/users?role=Instructor`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        setInstructorNames(
          data.msg.map((e) => {
            return {
              id: e._id,
              firstName: e.first_name,
              lastName: e.last_name,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const blog = { name, instructor, membership, level, price, text };

    setIsPending(true);

    let formData = new FormData();
    for (const [key, value] of Object.entries(blog)) {
      formData.append(key, value);
    }
    formData.append("list", list1);
    formData.append("list", list2);
    formData.append("list", list3);
    formData.append("list", list4);

    formData.append("photo", photo);
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/course`, {
      method: "POST",
      body: formData,
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        setIsPending(false);
        history.push("/dashboard/allcourses");
      });
  };

  // if (loading) {
  //   return (
  //     <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
  //       <div className="lds-dual-ring"></div>
  //     </div>
  //   );
  // }

  return loading ? (
    <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
      <div className="lds-dual-ring"></div>
    </div>
  ) : (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="add-page mt-3">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <h3>
                      <i className="fa fa-plus"></i> Add Course
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="datails-content">
                      <label>Course Name</label>
                      <input
                        type="text"
                        placeholder="Course Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="datails-content">
                      <label>Course Image</label>
                      <input
                        type="file"
                        onChange={(e) => {
                          setPhoto(e.target.files[0]);
                        }}
                      />
                    </div>

                    <div className="datails-content">
                      <label>Instructor</label>
                      <select
                        onChange={(e) => {
                          setInstructor(e.target.value);
                        }}
                      >
                        <option value=""></option>
                        {instructorNames.map((n, index) => (
                          <option value={n.id} key={index}>
                            {n.firstName + " " + n.lastName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="datails-content">
                      <label>Membership</label>
                      <select
                        onChange={(e) => {
                          setMembership(e.target.value);
                        }}
                      >
                        <option value=""></option>
                        <option value="premiumPlan">Premium</option>
                        <option value="freePlan">Free</option>
                      </select>
                    </div>
                    <div className="datails-content">
                      <label>Price</label>
                      {membership === "freePlan" ? (
                        <input disabled className="dis" />
                      ) : (
                        <input
                          type="number"
                          placeholder="Price"
                          // value={price}
                          onChange={(e) => setPrice(e.target.value)}
                        />
                      )}
                    </div>

                    <div className="datails-content">
                      <label>Level</label>
                      <select
                        onChange={(e) => {
                          setLevel(e.target.value);
                        }}
                      >
                        <option value=""></option>
                        <option value="A1">A1</option>
                        <option value="A2">A2</option>
                        <option value="B1">B1</option>
                        <option value="B2">B2</option>
                        <option value="C1">C1</option>
                        <option value="C2">C2</option>
                      </select>
                    </div>

                    <div className="datails-content-text">
                      <label>About Course</label>
                      <textarea
                        type="text"
                        placeholder="About Course"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                      />
                    </div>
                    <div className="datails-content-text">
                      <label>what will you learn 1</label>
                      <textarea
                        type="text"
                        placeholder="what will you learn"
                        value={list1}
                        onChange={(e) => setList1(e.target.value)}
                      />
                    </div>
                    <div className="datails-content-text">
                      <label>what will you learn 2</label>
                      <textarea
                        type="text"
                        placeholder="what will you learn"
                        value={list2}
                        onChange={(e) => setList2(e.target.value)}
                      />
                    </div>
                    <div className="datails-content-text">
                      <label>what will you learn 3</label>
                      <textarea
                        type="text"
                        placeholder="what will you learn"
                        value={list3}
                        onChange={(e) => setList3(e.target.value)}
                      />
                    </div>
                    <div className="datails-content-text">
                      <label>what will you learn 4</label>
                      <textarea
                        type="text"
                        placeholder="what will you learn"
                        value={list4}
                        onChange={(e) => setList4(e.target.value)}
                      />
                    </div>
                    {!isPending && (
                      <button className="contButSmall">Save </button>
                    )}
                    {isPending && (
                      <button className="contButSmall">Saving...</button>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCourse;
